import React from "react";

import { Phone } from "../../models";
import { Clickable } from "../Clickables";

import styles from "./LocationListItem.module.scss";

export const PhoneNumber = (props: { phone: Phone }) => (
    <Clickable href={`tel:${props.phone.e164}`} className={styles.text}>
        {props.phone.national}
    </Clickable>
);
